import { useCallback, useEffect, useState } from "react";
// @ts-ignore
import ChartTrip from "../../models/ChartTrip";
// @ts-ignore
import { PromisifyPostModel } from "../../utils/PromisifyRequest";
import { dataToGeoJSON, endpointToGeom, routeToGeom } from "./dataToGeoJSON";

//const defaultFilter = null;
const defaultFilter: any | null = null;
type nullStateType = {
  type: string;
  features: any;
};
const nullState: nullStateType = {
  type: "FeatureCollection",
  features: [],
};
type defaultDataType = {
  routes: nullStateType;
  endpoints: nullStateType;
  length?: number;
};
const defaultData: defaultDataType = {
  routes: nullState,
  endpoints: nullState,
  length: 0,
};

const ChartTripFetch: any = PromisifyPostModel(ChartTrip);
export default () => {
  const [data, setData] = useState(defaultData);
  const [filter, setFilter] = useState(defaultFilter);

  const getData: () => Promise<void> = useCallback(async (): Promise<void> => {
    if (filter !== null) {
      try {
        const {
          from,
          to,
          distance,
          distanceDisabled,
          amountOfRoutes,
          maxSpeed,
          filter_type,
          trip_type,
        } = JSON.parse(JSON.stringify(filter));
        const formatDistance: (distance: any) => any = (distance: any): any => {
          if (distance.indexOf(",")) {
            distance = distance.replace(",", ".");
            distance = parseFloat(distance);
          } else if (distance.indexOf(".")) {
            distance = parseFloat(distance);
          } else {
            distance = parseInt(distance);
          }
          return distance;
        };
        const reqBody = {
          from,
          to,
          ...(distance !== null &&
            !distanceDisabled && { distance: formatDistance(distance) * 1000 }),
          ...(filter_type === 1 // filterType.speed
            ? maxSpeed !== null && { maxSpeed }
            : amountOfRoutes !== null && { amountOfRoutes }),
          trip_type,
        };

        const response: any = await ChartTripFetch(reqBody);
        // Currently needs flat due to API
        const data: any = response.data;
        const routes: {
          type: string;
          crs: { type: string; properties: { name: string } };
          features: any[];
        } = dataToGeoJSON(routeToGeom)(data);
        const endpoints: {
          type: string;
          crs: { type: string; properties: { name: string } };
          features: any[];
        } = dataToGeoJSON(endpointToGeom)(data);
        setData({ routes, endpoints, length: routes.features.length });
      } catch (err) {
        console.error("Cannot fetch data from API", err);
      }
    }
  }, [filter]);

  useEffect((): void => {
    getData();
  }, [getData]);

  return [data, setFilter];
};
